export default "__VITE_ASSET__6e84c009__"